import { LazyCopilotAdminBanner } from '@ms/yammer-web-components/dist/copilot/CopilotAdminBanner';
import { useLeadershipCornerBanner } from '@ms/yammer-web-components/dist/leadershipCorner/LeadershipCornerBanner';
import Flex from '@ms/yammer-web-core-ui/dist/components/Flex';
import React, { useMemo } from 'react';

export const useGetBanners = () => {
  const leadershipCornerBanner = useLeadershipCornerBanner();

  return useMemo(() => {
    const hasBanner = leadershipCornerBanner;

    const renderContent = hasBanner ? (
      <Flex grow={1} direction="column">
        {leadershipCornerBanner}
        <LazyCopilotAdminBanner />
      </Flex>
    ) : (
      <Flex grow={1} direction="column">
        <LazyCopilotAdminBanner />
      </Flex>
    );

    return renderContent;
  }, [leadershipCornerBanner]);
};
